import {
  BonusStrategy,
  BonusType,
  BonusResult,
  ConfettiConfig,
  AmountConstraints,
} from '../interfaces/bonus.interface';

export class EscalonadoBonusStrategy implements BonusStrategy {
  type = BonusType.ESCALONADO;
  campaignSpecific = false; // Bono genérico reutilizable en múltiples campañas

  validateAmount(amount: number): boolean {
    return amount >= 5000000;
  }

  calculateBonus(amount: number, termDays: number): BonusResult {
    const terms = this.getTermsAndConditions();
    if (!this.validateAmount(amount)) {
      return {
        isValid: false,
        bonusAmount: 0,
        message: '',
        confettiType: '',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }
    let bonusAmount = 0;
    if (amount >= 30000000) {
      bonusAmount = 300000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message:
          'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$300.000</b> extra directo a tu cuenta.',
        message_simulador: `Puedes aplicar para un bono de $300.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.`,
        confettiType: 'snow',
        displayAmount: '$300.000',
        bonusTag: '300k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'ESCALONADO_300K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 10000000) {
      bonusAmount = 100000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message:
          'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$100.000</b> extra directo a tu cuenta.',
        message_simulador: `Puedes aplicar para un bono de $100.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.`,
        confettiType: 'snow',
        displayAmount: '$100.000',
        bonusTag: '100k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'ESCALONADO_100K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    } else if (amount >= 5000000) {
      bonusAmount = 50000 * (termDays / 360);
      return {
        isValid: true,
        bonusAmount: Math.round(bonusAmount),
        message:
          'Además de tu rentabilidad, llévate <b class="tag-bono-amt text-white py-1 px-3 rounded-pill">$50.000</b> extra directo a tu cuenta.',
        message_simulador: `Puedes aplicar para un bono de $50.000. Continua con <b>la apertura de tu CDT</b> para obtenerlo.`,
        confettiType: 'snow',
        displayAmount: '$50.000',
        bonusTag: '50k',
        minTermDays: [30, 60, 90, 180],
        tagNameBonusType: 'ESCALONADO_50K',
        termsAndConditionsUrl: terms.url,
        termsAndConditionsDescription: terms.description,
      };
    }
    return {
      isValid: false,
      bonusAmount: 0,
      message: '',
      confettiType: '',
      termsAndConditionsUrl: terms.url,
      termsAndConditionsDescription: terms.description,
    };
  }

  getTermsAndConditions(): { url: string; description: string } {
    return {
      url: '/legal/bonos/bono-escalonado',
      description:
        'Para ser elegible para el bono de MejorCDT a través de la promoción de un influencer, debes iniciar el proceso de simulación y apertura de tu CDT haciendo clic en el enlace exclusivo proporcionado por dicho influencer. La promoción aplica tanto para clientes nuevos como existentes, siempre que la inversión sea un nuevo CDT con un plazo mínimo de 12 meses y un monto igual o superior a $5,000,000 COP. No serás elegible si inicias el proceso directamente desde la página principal de MejorCDT o por otros medios. El valor del bono es un cashback que se transfiere a tu cuenta bancaria personal, y varía según tu inversión: $50,000 COP para montos entre $5,000,000 y $9,999,999, $100,000 COP para montos entre $10,000,000 y $29,999,999, y $300,000 COP para inversiones de $30,000,000 en adelante. Para recibir el bono, es crucial que la titularidad de la cuenta bancaria coincida con la del CDT, ya que no se permiten transferencias a terceros. El bono no es acumulable con otras promociones, se entrega un máximo de uno por cliente por campaña, y se aplica sobre la primera inversión que cumpla las condiciones. MejorCDT se reserva el derecho de anular el bono si se detecta actividad fraudulenta.',
    };
  }

  getConfettiConfig(): ConfettiConfig {
    return {
      type: 'snow',
      duration: 4000,
      intensity: 'medium',
    };
  }

  getAmountConstraints(): AmountConstraints {
    return {
      locked: false,
      minAmount: 5000000,
    };
  }
}
